import React, { useState, useEffect } from "react";
import { Form, Empty, Button, Descriptions } from "antd";
import { connect } from "react-redux";
import { MerchantService } from "../../services";
import { handleApiExceptions, alertify } from "../../app_methods";
import { updateCurrentUserAction } from "../../redux/actions";
import { Text4 } from "../../styles";
import { PermissionHoc } from "../HOC";

let TallyInvoiceForm = (props) => {
    const { form } = props;
	const { getFieldDecorator } = form;
	const [isSaving, setIsSaving] = useState(false);
    const PermissableButton = PermissionHoc(Button, null, { is_component: true, fallbackComponent: null })
	
    const onSubmit = (e) => {
		e.preventDefault();
		form.validateFields(async (err, values) => {
			if (err) return;
			setIsSaving(true);
			const response = await MerchantService.generate_tally_credentials();
			if (!response.success) {
				setIsSaving(false);
				handleApiExceptions(response);
				return;
			}
			if (response.data.success){
				alertify("Success", response.data.message, "success");
			} else {
				alertify("Error", response.data.message, "error");
			}
			setIsSaving(false);
			fetchMerchantInfo()
		});
	};

	const fetchMerchantInfo = () => {
        MerchantService.fetch().then((response) => {
            if (response.success) props.updateCurrentUser(response.data.merchant);
        });
    };
    
    return (
        <div className="row">
			<div className="col-sm-12 col-md-12 col-lg-12">
				<Form onSubmit={onSubmit}>
					{!(props.current_user.tally_credentials && props.current_user.tally_credentials.tally_account_email) ?
						<div className="w-100 d-flex justify-content-center align-self-center generate_tally_button" >
							<Empty
								description={
									<span>Generate your Tally credentials in order to start syncing invoices.</span>
								}
							>
								<PermissableButton required_permission="TALLY_INVOICES_WRITE" onClick={onSubmit} loading={isSaving}>Generate Tally Credentials</PermissableButton>
							</Empty>
						</div>
						:
						<div className="w-50">
							<Descriptions column={1} bordered>
								<Descriptions.Item label="Tally Account Username">
									<Text4>{props.current_user.tally_credentials.tally_account_email}</Text4>
								</Descriptions.Item>
							</Descriptions>
						</div>
					}
					<div className="w-100 d-flex   mt-4">
					</div>
				</Form>
			</div>
		</div>
    );
};


TallyInvoiceForm = Form.create()(TallyInvoiceForm);

const mapStateToProps = (state) => ({
	current_user: state.userReducer.current_user,
});

const mapDispatchToProps = (dispatch) => ({
	updateCurrentUser: (user) => dispatch(updateCurrentUserAction(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TallyInvoiceForm);